import React from "react";
import { BsPencil, BsTrash } from "react-icons/bs";

import { useAppDispatch } from "../../../../app/hooks";
import { DriverV2 } from "../../../../models";
import {
  setSelectedDriver,
  toggleShowEditDriverModal,
  showDeleteDriverConfirmationModal,
} from "../../../DriversV2/driversV2Slice";
import { PhoneNumber } from "../../../../components";

import "./DriverDetailsCard.scss";

export interface DriverDetailsCardProps {
  driver: DriverV2;
}

export function DriverDetailsCard(props: DriverDetailsCardProps) {
  const dispatch = useAppDispatch();
  const { driver } = props;

  const onEditDriverClick = () => {
    dispatch(setSelectedDriver(driver));
    dispatch(toggleShowEditDriverModal());
  };

  const onDeleteDriverClick = () => {
    dispatch(showDeleteDriverConfirmationModal(driver));
  };

  return (
    <div className="driver-details-card-component">
      <div className="header">
        <div className="header-title">Driver Details</div>

        <div className="buttons-container">
          <div className="button-container" onClick={onEditDriverClick}>
            <BsPencil className="icon" />
            <div>Edit Driver</div>
          </div>

          <div className="button-container" onClick={onDeleteDriverClick}>
            <BsTrash className="icon" />
            <div>Delete Driver</div>
          </div>
        </div>
      </div>

      <div className="details-container">
        <div className="column">
          <div className="item-container">
            <div className="label">Name:</div>
            <div className="value bold">{driver.name}</div>
          </div>

          <div className="item-container">
            <div className="label">Email:</div>
            <div className="value">{driver.email}</div>
          </div>

          <div className="item-container">
            <div className="label">Phone:</div>
            <div className="value">
              <PhoneNumber phoneNumber={driver.phoneNumber} />
            </div>
          </div>
        </div>

        <div className="column">
          <div className="item-container">
            <div className="label">Address:</div>
            <div className="value">{driver.address || "N/A"}</div>
          </div>

          <div className="item-container">
            <div className="label">City:</div>
            <div className="value">{driver.city || "N/A"}</div>
          </div>

          <div className="item-container">
            <div className="label">Zip:</div>
            <div className="value">{driver.zip || "N/A"}</div>
          </div>
        </div>

        <div className="column">
          <div className="item-container">
            <div className="label">DL Expiration:</div>
            <div className="value">{driver.dlExpiration || "N/A"}</div>
          </div>

          <div className="item-container">
            <div className="label">DOT Physical:</div>
            <div className="value">{driver.dotPhysicalExpiration || "N/A"}</div>
          </div>

          <div className="item-container">
            <div className="label">Start Time:</div>
            <div className="value">{driver.startTime || "N/A"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
